<template>
  <v-flex data-qa="redemptionquote-flex-wh2a02">
    <v-overlay v-show="loaderEnabled" :opacity="0.5" data-qa="redemptionquote-overlay-xufkv">
      <v-progress-circular
        :color="primaryColor"
        :size="70"
        :width="7"
        indeterminate
        class="circular-loader"
       data-qa="redemptionquote-progress-circular-l6kp97"></v-progress-circular>
      <font v-if="mortgageID" class="pl-4 text-h6">{{
        $t("redemptionQuoteLabels.mortgageRedLabel")
      }}</font>
      <font v-else class="pl-4 text-h6">{{
        $t("redemptionQuoteLabels.loanRedLabel")
      }}</font>
    </v-overlay>
    <v-layout wrap class="ml-2 pt-0" data-qa="redemptionquote-layout-pths5h">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="redemptionquote-flex-we5ifc">
        <v-container data-qa="redemptionquote-container-aadbae">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="redemptionquote-flex-ps79yl">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="redemptionquote-flex-myh1w">
              <v-row no-gutters class="pb-2" data-qa="redemptionquote-row-j3lldg">
                <v-flex xs2 sm1 md1 lg1 xl1 data-qa="redemptionquote-flex-w3h1w">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                </v-flex>
                <v-flex xs10 sm9 md9 lg9 xl9 class="pt-5" data-qa="redemptionquote-flex-p4c2j4">
                  <font
                    v-if="mortgageID"
                    class="headline font-weight-light white--text pl-2"
                    >{{ $t("redemptionQuoteLabels.mortgageRedLabel") }}</font
                  >
                  <font
                    v-else
                    class="headline font-weight-light white--text pl-2"
                  >
                    {{ $t("redemptionQuoteLabels.loanRedLabel") }}
                  </font>
                </v-flex>
              </v-row>
            </v-flex>
            <v-row class="px-2 pl-6" data-qa="redemptionquote-row-h53qsy">
              <v-layout row wrap data-qa="redemptionquote-layout-uwuax">
                <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="redemptionquote-flex-dnr6sl">
                  <font
                    v-if="mortgageID"
                    class="subheading-1 font-weight-medium white--text"
                  >
                    {{ $t("loanDetails.mortgageNumber") }}
                  </font>
                  <font
                    v-else
                    class="subheading-1 font-weight-medium white--text"
                  >
                    {{ $t("loanDetails.loanId") }}
                  </font>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="redemptionquote-flex-amtfy5">
                  <font
                    v-if="mortgageID"
                    class="text-h5 font-weight-bold white--text"
                  >
                    {{ mortgageID }}
                  </font>
                  <font v-else class="text-h5 font-weight-bold white--text">
                    {{ loanId }}
                  </font>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="redemptionquote-flex-4x87i">
      <v-row no-gutters data-qa="redemptionquote-row-uc7h5r">
        <v-flex class="pl-4 pr-4 md-4" xs12 sm5 md4 lg4 xl4 data-qa="redemptionquote-flex-y2wjgl">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="10"
            transition="scale-transition"
            offset-y
            min-width="250px"
           data-qa="redemptionquote-menu-ejn274">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="formattedFromDate"
                :label="$t('loanDetails.settlementDate')"
                append-icon="mdi-calendar"
                readonly
                v-on="on"
                data-qa="fromDate"
                :color="primaryColor"
                :rules="fromDateRules"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fromDate"
              @input="menu = false"
              :allowed-dates="allowedDates"
              :min="currentDate"
              :max="settlementDate"
              data-qa="fromDate"
              :color="primaryColor"
              @change="updateFormattedDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-spacer data-qa="redemptionquote-spacer-sldqp" />
        <v-flex v-if="enableEmailQuoteOption && redemptionQuoteData && !redemptionQuoteData.data" xs12 sm5 md4 lg4 xl4 class="pb-2 text-end" data-qa="redemptionquote-flex-ut863">
          <v-btn
            @click="requestEmailQuote"
            :color="secondaryColor"
            outlined
            class="px-4 py-2"
           data-qa="redemptionquote-btn-sifc6">
            <span class="text-none" data-qa="redemptionquote-span-sb9wl">{{$t('redemptionQuoteLabels.button.emailQuote')}}</span>
            <v-icon :color="secondaryColor" class="pl-2 material-symbols-outlined" size="18px" data-qa="redemptionquote-icon-sam6au">mail</v-icon>
          </v-btn>
        </v-flex>
      </v-row>
      <v-card tile class="py-2 ml-3" data-qa="redemptionquote-card-4kufu">
        <v-flex xs12 sm12 md12 lg12 xl12 class="pl-1 mt-5" data-qa="redemptionquote-flex-pp4ljw">
          <template v-for="(data, index) in displayDataArr">
            <v-divider
              v-if="data.label === $t('redemptionQuoteLabels.settlAmt')"
              :key="index"
              :data-qa="`redemptionquote-divider-kc5igh-${index}`"></v-divider>
            <v-row :key="index" no-gutters class="mt-5 mb-5" :data-qa="`redemptionquote-row-iz9qa4u-${index}`">
              <v-flex xs8 sm8 md8 lg8 xl8 :class="[ data.isFontBold ? 'font-weight-bold' : '', 'pl-6' ]" :data-qa="`redemptionquote-flex-otytn-${index}`">
                {{ data.label }}
              </v-flex>
              <v-flex xs4 sm4 md4 lg4 xl4 :class="[ data.isFontBold ? 'font-weight-bold' : '', 'text-end', 'pr-6' ]"
                :data-qa="`redemptionquote-flex-1i2s8-${index}`">{{ data.value }}
              </v-flex>
            </v-row>
          </template>
        </v-flex>
      </v-card>
      <v-row no-gutters class="mt-3 mb-3" data-qa="redemptionquote-row-jz8ue8">
        <v-col data-qa="redemptionquote-col-vjh0pp">
          <v-btn text
            class="text-capitalize py-2 px-4"
            :color="primaryColor"
            @click="goBack" data-qa="redemptionquote-btn-i4mzfl">
            <v-icon class="material-symbols-outlined" left data-qa="redemptionquote-icon-mcmcnd">arrow_back</v-icon>
            {{ $t("common.goBack") }}
          </v-btn>
        </v-col>
        <v-spacer data-qa="redemptionquote-spacer-lqqun"  />
        <v-col v-if="mortgageID" data-qa="redemptionquote-col-q8guns">
          <v-btn text :color="primaryColor" @click="goToMortgageAccountsDisplay" data-qa="redemptionquote-btn-0t61ch">
            {{ $t("mortgage.viewAcc") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-flex>
    <v-flex class="pa-2 ml-3 text-left" xs12 sm12 md8 lg8 xl8 data-qa="redemptionquote-flex-gtzn75">
      <span data-qa="redemptionquote-span-k9y2n">
        <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="redemptionquote-alert-knzqg6">
          <font v-if="mortgageID" class="body-2">{{ $t('redemptionQuoteLabels.mortgageLegend') }}</font>
          <font v-else class="body-2">{{ $t('redemptionQuoteLabels.loanLegend') }}</font>
        </v-alert>
      </span>
    </v-flex>
    <Modal
      v-if="showEmailRedemptionModal"
      :config="modalConfig.redemptionQuote"
      @btn2Action="onSuccessModalClose"
    >
    </Modal>
  </v-flex>
</template>

<script>
import CommonService from '@/service/commonService.js'

export default {
  name: 'Mortgage',
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      loaderEnabled: false,
      showEmailRedemptionModal: false,
      isEmailRedemptionSuccess: false,
      redemptionData: {
        title: this.$t('redemptionQuoteLabels.loanRedLabel'),
        cardLabels: false,
        openNewACCard: false,
        accounts: []
      },
      modalConfig: {
        redemptionQuote: {
          enabled: true,
          title: this.$t('redemptionQuoteLabels.emailQuote.title'),
          subtitle: '',
          persistent: true,
          btn2Label: this.$t('common.okay'),
          width: 500
        }
      },
      fromDateRules: [],
      currentDate: '',
      settlementDate: '',
      fromDate: new Date().toISOString().substr(0, 10),
      redemptionQuoteData: {},
      menu: false,
      loanId: undefined,
      loanStatus: '',
      mortgageID: '',
      mortgageAgreement: '',
      totalOutAmount: 0,
      totInterest: 0,
      principal: 0,
      totChargMisc: 0,
      totSettlmntCharge: 0,
      taxScheduleCharge: 0,
      totSurpCharge: 0,
      totSettlmntAmt: 0,
      displayDataArr: [],
      enableEmailQuoteOption: this.$appSettings.defaultConfigurations.loanScreen.redemptionQuote.enableEmailQuoteOption,
      settlementDateLimiter: this.$appSettings.defaultConfigurations.loanScreen.redemptionQuote.settlementDateLimiter,
      isSmeLogin: false
    }
  },
  beforeMount () {
    if (!this.$route.params.loanId && !this.$route.params.mortgageID) {
      this.goBack()
    }
    if (!this.$route.params.mortgageID && !this.$route.params.loanId) {
      this.goBack()
    }
  },
  created () {
    this.loanId = this.$route.params.loanId
    this.loanStatus = this.$route.params.loanStatus
    this.mortgageID = this.$route.params.loanId
      ? ''
      : this.$route.params.mortgageID || sessionStorage.getItem('currentPage-mortgageID')
    sessionStorage.setItem('currentPage-mortgageID', this.mortgageID)
    this.isSmeLogin = JSON.parse(sessionStorage.getItem('isSmeLogin'))
    this.mortgageAgreement = this.$route.params.mortgageAgreement
      ? this.$route.params.mortgageAgreement
      : ''
    this.formattedFromDate = this.$formatter.formatDate(this.fromDate)
    this.currentDate = new Date().toJSON().slice(0, 10).split('-').join('-')
    const setCurrDate = new Date()
    setCurrDate.setDate(setCurrDate.getDate() + this.settlementDateLimiter)
    const maturityDate = new Date(this.$route.params.maturityDate)
    this.settlementDate = !this.isSmeLogin ? (maturityDate < setCurrDate ? maturityDate : setCurrDate).toISOString().substr(0, 10) : ''
    this.getSettlementForecast(this.fromDate)
  },
  methods: {
    getIcon (item) {
      return item ? 'mdi-check' : 'mdi-close'
    },
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    onSuccessModalClose () {
      this.showEmailRedemptionModal = false
    },
    goBack () {
      if (this.loanId) {
        this.$router.replace({
          name: 'LoanDetails',
          params: { loanId: this.loanId, mortgageID: this.mortgageID, mortgageAgreement: this.mortgageAgreement }
        })
      } else {
        this.goToMortgageAccounts()
      }
    },
    goToMortgageAccounts () {
      this.$router.push({
        name: 'Mortgage',
        params: { mortgageID: this.mortgageID }
      })
    },
    goToMortgageAccountsDisplay () {
      this.$router.push({
        name: 'MortgageAccountListDisplay',
        params: { mortgageID: this.mortgageID }
      })
    },
    getNavigationIcon () {
      return this.getSvgIconSrc('Loan_Dashboard')
    },
    allowedDates: (val) => parseInt(val.split('-')[2], 10) % 1 === 0,
    updateFormattedDate () {
      this.formattedFromDate = this.$formatter.formatDate(this.fromDate)
      this.getSettlementForecast(this.fromDate)
    },
    async requestEmailQuote () {
      const redemptionQuoteData = this.mortgageID
        ? await CommonService.getMortgageSettlementForecast(this.mortgageID, this.fromDate, true)
        : await CommonService.getLoanSettlementForecast(this.loanId, this.fromDate, true)
      if (redemptionQuoteData && !redemptionQuoteData.data && redemptionQuoteData.quoteDocumentReference) {
        this.showEmailRedemptionModal = true
        this.isEmailRedemptionSuccess = true
        this.modalConfig.redemptionQuote.subtitle = this.$t('redemptionQuoteLabels.emailQuote.success')
        this.modalConfig.redemptionQuote.enabled = true
      } else if (redemptionQuoteData && redemptionQuoteData.causes.length && redemptionQuoteData.causes[0].code === '40312449') {

      } else {
        this.modalConfig.redemptionQuote.enabled = true
        this.showEmailRedemptionModal = true
        this.isEmailRedemptionSuccess = false
        this.modalConfig.redemptionQuote.subtitle = this.$t('redemptionQuoteLabels.emailQuote.failure')
      }
    },
    insertDataToArray (item) {
      this.displayDataArr.push({
        label: item.label,
        value: this.$formatter.currency.format(item.value, item.currency),
        isFontBold: item?.isFontBold
      })
    },
    async getSettlementForecast (selectedDate) {
      let totSettlmntCharge = 0
      const redemptionQuoteData = this.mortgageID
        ? await CommonService.getMortgageSettlementForecast(this.mortgageID, selectedDate)
        : await CommonService.getLoanSettlementForecast(this.loanId, selectedDate)
      this.redemptionQuoteData = redemptionQuoteData
      if (redemptionQuoteData && !redemptionQuoteData.data) {
        this.totalOutAmount = redemptionQuoteData.principalOutstanding.amount +
            redemptionQuoteData.interestOutstanding.amount

        this.principal = redemptionQuoteData.principalOutstanding.amount

        this.totInterest = redemptionQuoteData.interestOutstanding.amount

        this.totChargMisc = redemptionQuoteData.scheduleCharges.amount

        this.totSurpCharge = redemptionQuoteData.surplusAmount.amount

        this.taxScheduleCharge = redemptionQuoteData.taxScheduleCharge.amount

        if (redemptionQuoteData.loanSettleCharges && redemptionQuoteData.loanSettleCharges.length) {
          const settlementCharges = redemptionQuoteData.loanSettleCharges
          for (const i in settlementCharges) {
            totSettlmntCharge += settlementCharges[i].chargeAmount.amount
          }
        }
        this.totSettlmntCharge = totSettlmntCharge
        this.totSettlmntAmt = redemptionQuoteData.totalSettlementAmount.amount

        this.displayDataArr = []
        const dataArray = [
          { label: this.$t('redemptionQuoteLabels.principal'), value: this.principal, currency: redemptionQuoteData.principalOutstanding.currency },
          { label: this.$t('redemptionQuoteLabels.interest'), value: this.totInterest, currency: redemptionQuoteData.interestOutstanding.currency },
          { label: this.$t('redemptionQuoteLabels.chargAndMisc'), value: this.totChargMisc, currency: redemptionQuoteData.arrearScheduleCharges.currency },
          { label: this.$t('redemptionQuoteLabels.settlemnetCharge'), value: this.totSettlmntCharge, currency: redemptionQuoteData.totalSettlementAmount.currency },
          { label: this.$t('redemptionQuoteLabels.taxScheduleCharge'), value: this.taxScheduleCharge, currency: redemptionQuoteData.taxScheduleCharge.currency },
          { label: this.$t('redemptionQuoteLabels.surpBal'), value: this.totSurpCharge, currency: redemptionQuoteData.surplusAmount.currency },
          { label: this.$t('redemptionQuoteLabels.settlAmt'), value: this.totSettlmntAmt, currency: redemptionQuoteData.totalSettlementAmount.currency, isFontBold: true }
        ]
        // If the loan status is 'InArrears', then total outstanding balance index is 2 else 0 (In this.displayDataArr array)
        const totOutBalIndex = this.loanStatus === 'InArrears' ? 2 : 0
        dataArray.splice(totOutBalIndex, 0, { label: this.$t('redemptionQuoteLabels.totOutBal'), value: this.totalOutAmount, currency: redemptionQuoteData.totalSettlementAmount.currency, isFontBold: true })

        dataArray.forEach(item => {
          if (item.value) {
            if ((this.loanStatus === 'InArrears') && (item.label === this.$t('redemptionQuoteLabels.surpBal'))) {
              this.insertDataToArray(item)
            } else if ((this.loanStatus !== 'InArrears') && (item.label !== this.$t('redemptionQuoteLabels.surpBal'))) {
              this.insertDataToArray(item)
            } else {
              if ((item.label !== this.$t('redemptionQuoteLabels.surpBal'))) {
                this.insertDataToArray(item)
              }
            }
          }
        })
      }
    }
  }
}
</script>
